import { render, staticRenderFns } from "./MoveFunds.vue?vue&type=template&id=33804ab0&"
import script from "./MoveFunds.vue?vue&type=script&lang=js&"
export * from "./MoveFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports